import React from 'react';

const CustomizedAxisTick = ({ x, y, payload }) => {
  const text = payload.value;
  let chunksToRender = [];

  const chunkSize = 2;
  if (text.length > 10) {
    const words = text.split(/\s+/).filter(word => word.length > 0);

    for (let i = 0; i < words.length; i += chunkSize) {
      const chunk = words.slice(i, i + chunkSize);
      const newLine = (
        <tspan x={0} dy="1.2em" key={i}>
          {chunk.join(' ')}
        </tspan>
      );
      chunksToRender.push(newLine);
    }
  } else {
    chunksToRender = text;
  }

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        fill="#666"
        transform="rotate(-35)"
      >
        {chunksToRender}
      </text>
    </g>
  );
};

export default CustomizedAxisTick;
